import React, { useEffect } from 'react'
import './AboutUs.scss'

import arrow from '../../../assets/Pictures/arrowAboutus.svg'

import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function AboutUs() {
  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='aboutUsPart'>
      <div className="container">
        <div className="row">
          <div className="aboutUs_contents" data-aos='fade-left'>
            <div className="aboutUs_content">
              <h1 className="ourProducts_contents_title">
                GLOBAL ENERGY INVESTMENT
              </h1>
              <h3 className="ourProducts_contents_subtitle">
                Çelik Sanayi, İnşaat, geri dönüşüm ve atıklardan enerji santrali sektöründe faaliyet gösteren Mühendislik, Danışmanlık ve Uluslararası Ticaret şirketiyiz. Şirketlerimiz ağırlıklı olarak Türkiye ve Umman'da faaliyet göstermektedir. Vigor Global Enerji şirketi “VGE” İstanbul, Türkiye'de ve Global Enerji Yatırım şirketi “GEI” Muscat, Umman'da bulunmaktadır.
                <br />
                <br />
                Çelik sektöründe faaliyet gösteren şirketlerimiz Ortadoğu'nun en büyük çelik ürünleri üreticilerinden biri olan Kavir Çelik Kompleksi'nin Türkiye, Umman ve Afrika ülkelerindeki resmi temsilcisidir. filmaşin, çelik külçe ve inşaat demiri gibi yüksek kalitedeki özel kalite ve Avrupa sertifikalarına sahip Demir Çelik ürünlerinin ham madde olarak kullanılan çeşitli fabrikalara ihracatı için Türkiye, Umman ve diğer ülkelerin önde gelen imalat ve inşaat firmaları ile yakın işbirliği içinde çalışmaktayız. 
                <br />
                <img src={arrow} alt="arrow" /> <Link to='/corperate'>more</Link>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="aboutUsImage" data-aos='fade-right'>
      </div>
    </div>
  )
}
